import {all, call} from 'redux-saga/effects';
import {quickCheckoutSaga} from 'features/quickCheckout/sagas/checkout/quick/quick';
import {categorySaga as categoryRefinementsSaga} from 'features/categoryRefinements/sagas/category/category';
import {sendPrescriptionSaga} from 'features/uploadRx/sagas/sendPrescription/sendPrescription';
import {headerSaga} from 'sagas/header/header';
import {rootWizardMsSaga} from 'features/wizardMs/sagas';
import {rootContactsSaga} from 'features/contacts/sagas';
import {rootReorderSaga} from 'features/reorder/sagas';
import {myFitSaga} from 'features/myFit/sagas/myFit';
import {logWithSentry} from 'libs/sentry/sentry';
import {ENVIRONMENT} from 'constants/app';

import appSaga from './app/app';
import checkoutSaga from './checkout';
import menuSaga from './menu/menu';
import productSaga from './product/product';
import cmsBannerSaga from './cmsBanner/cmsBanner';
import categorySaga from './category/category';
import subscriptionSaga from './subscription/subscription';
import searchResultsSaga from './searchResults/searchResults';
import genderSaga from './gender/gender';
import contactsPageSaga from './contacts/contacts';
import customerSaga from './customer/customer';
import wishlistSaga from './wishlist/wishlist';
import homeTryOnSaga from './homeTryOn/homeTryOn';
import referralPromoCodeSaga from './referralPromoCode/referralPromoCode';
import stickySaga from './product/sticky/sticky';
import oAuth from './oAuth/oAuth';
// Analytics
import globalDataLayerSaga from './globalDataLayer/globalDataLayer';
import dataLayerSaga from './generalAnalytics/dataLayer/global/global';
import EEC from './EEC';
import GTM from './GTM';
import analyticsSaga from './analytics/analytics';
import affiliateSaga from './affiliate/affiliate';
import impactRadius from './analytics/impactRadius';
import bronto from './bronto/bronto';
import speedCurve from './analytics/speedCurve';
import riskified from './riskified';
import {rolloutFlagsSaga} from './rolloutFlags/rolloutFlags';
import {marketingAPI} from './marketingAPI/marketingAPI';

/**
 * RootSaga
 */
export default function* rootSaga() {
    try {
        yield all([
            customerSaga(),
            appSaga(),
            checkoutSaga(),
            menuSaga(),
            productSaga(),
            globalDataLayerSaga(),
            dataLayerSaga(),
            categorySaga(),
            subscriptionSaga(),
            cmsBannerSaga(),
            searchResultsSaga(),
            genderSaga(),
            contactsPageSaga(),
            affiliateSaga(),
            EEC(),
            analyticsSaga(),
            wishlistSaga(),
            homeTryOnSaga(),
            stickySaga(),
            referralPromoCodeSaga(),
            sendPrescriptionSaga(),
            impactRadius(),
            bronto(),
            speedCurve(),
            riskified(),
            quickCheckoutSaga(),
            GTM(),
            headerSaga(),
            rolloutFlagsSaga(),
            categoryRefinementsSaga(),
            oAuth(),
            rootWizardMsSaga(),
            marketingAPI(),
            rootContactsSaga(),
            rootReorderSaga(),
            myFitSaga(),
        ]);
    } catch (error) {
        logWithSentry(error, 'sagas failed');

        if (ENVIRONMENT !== 'production') {
            // eslint-disable-next-line no-console
            yield call([console, 'error'], error);
        }
    }
}
